import { useEffect } from "react";
import { useForm } from "react-hook-form";
import styles from "./profileform.module.css";
import {
  Input,
  Button,
  SubHeadingTitle,
} from "../../../../../components/shared";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useUserProfile,
  useAddUserProfile,
  useUpdateUserProfile,
} from "../../../../../queries/useUserProfile";
const ProfileForm = () => {
  const { data: profileRes, isLoading } = useUserProfile();
  const addMutation = useAddUserProfile();
  const updateMutation = useUpdateUserProfile();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      mobile: "",
      gender: "",
      subscribe: true,
    },
  });
  const profileData = profileRes?.data; // from backend /backend/profile
  const isUpdateMode = !!profileData?.id;
  useEffect(() => {
    if (profileData) {
      setValue("name", profileData.username || "");
      setValue("email", profileData.email || "");
      setValue("mobile", profileData.phone_number || "");
      setValue("gender", profileData.gender || "");
      setValue("subscribe", profileData.subscribe ?? true);
    }
  }, [profileData, setValue]);
  const onSubmit = async (formData) => {
    try {
      const payload = new FormData();

payload.append("username", formData.name);
payload.append("email", formData.email);
payload.append("phone_number", formData.mobile);
payload.append("gender", formData.gender);
      if (!isUpdateMode) {
        await addMutation.mutateAsync(payload);
       Swal.fire({
  icon: "success",
  title: "Success",
  text: "Profile added successfully",
  confirmButtonColor: "#FB6C22",
});
      } else {
       await updateMutation.mutateAsync(payload);
        Swal.fire({
  icon: "success",
  title: "Success",
  text: "Profile updated successfully",
  confirmButtonColor: "#1da7a3",
});
      }
    } catch (error) {
     Swal.fire({
  icon: "error",
  title: "Error",
  text: error.message || "Profile save failed",
  confirmButtonColor: "#d33",
});
    }
  };
  if (isLoading) return <p>Loading profile...</p>;  
  const handleDeleteAccount = () => {
  Swal.fire({
    title: "Are you sure?",
    text: "Do you really want to delete your account? This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it",
    cancelButtonText: "Cancel",
  }).then((result) => {
    if (result.isConfirmed) {
      // Here you can call delete API later if needed

      Swal.fire({
        icon: "success",
        title: "Request Received",
        text: "Your request has been received. Our technical team will review and process your account deletion shortly.",
        confirmButtonColor: "#127d17",
      }); 
    }
  });
};
  return (
    <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
      <div className={styles.row}>
        <Input
          label="Name"
          name="name"
          placeholder="Name"
          register={register}
          validation={{ required: "Name is required" }}
          error={errors?.name?.message}
        />
      </div>
      <div className={styles.row}>
        <Input
          name="mobile"
          label="Mobile Number"
         
            readOnly={isUpdateMode}
          placeholder="xxxxxxxxxx"
          register={register}
          validation={{
            required: "Mobile number is required",
            pattern: {
              value: /^[6-9]\d{9}$/,
              message: "Enter a valid 10-digit mobile number",
            },
          }}
          error={errors?.mobile?.message}
        />
        <Input
          label="Email"
          name="email"
           
            readOnly={isUpdateMode}
          placeholder="Enter email"
          register={register}
          validation={{ 
            required: "Email is required",
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: "Enter a valid email",
            },
          }}
          error={errors?.email?.message}
        />
      </div>
      <GenderSelector
        selectedGender={watch("gender")}
        onSelect={(g) => setValue("gender", g)}
      />
      <div className={styles.checkboxContainer}>
        <input
          type="checkbox"
          className={styles.subscribe}
          {...register("subscribe")}
        />
        <label>
          Keep up with our latest news and events. Subscribe to our newsletter.
        </label>
      </div>
      <Button
        title={isUpdateMode ? "Update Profile" : "Add Profile"}
        type="submit"
        style={styles.updateBtn}
        disabled={addMutation.isPending || updateMutation.isPending}
      />
      <p className={styles.deleteText}>
        Do you want to delete your account permanently?
       <Link
  className={styles.link}
  to="#"
  onClick={(e) => {
    e.preventDefault();
    handleDeleteAccount();
  }}
>
  Click here
</Link>
      </p>
    </form>
  );
};
const GenderSelector = ({ selectedGender, onSelect }) => {
  const genders = ["male", "female", "others"];

  return (
    <div className={styles.genderContainer}>
      <SubHeadingTitle style={styles.label} subTitle="Gender (optional)" />

      <div className={styles.buttonGroup}>
        {genders.map((gender) => (
          <Button
            key={gender}
            title={gender.charAt(0).toUpperCase() + gender.slice(1)}
            type="button"
            onHandler={() => onSelect(gender)}
            style={`${styles.genderBtn} ${
              selectedGender === gender ? styles.active : ""
            }`}
          />
        ))}
      </div>
    </div>
  );
};
export default ProfileForm;